export default __webpack_public_path__ + "static/media/finger_positions_1289_mobile.9290f19b.png";